import { MapPin, ExternalLink, Eye, Lock } from 'lucide-react'

interface MapsInfo {
  google_maps_url?: string
  street_view_url?: string
  plus_code?: string
  maps_embed_url?: string
}

interface LocationTabProps {
  address?: string
  address_area?: string
  maps?: MapsInfo
}

const LocationTab = ({ address, address_area, maps }: LocationTabProps) => {
  return (
    <div className="animate-fade-in-up space-y-5">
      <div>
        <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2">Location</h3>
        <p className="text-sm text-gray-500 mb-4">
          For guest safety, the full street address is shared only after your booking is confirmed.
        </p>
        <div className="flex items-start gap-3 rounded-xl bg-amber-50 border border-amber-200/80 p-4">
          <Lock className="h-5 w-5 text-amber-600 shrink-0 mt-0.5" />
          <div>
            <p className="font-semibold text-gray-900 text-sm sm:text-base">
              {address_area || address || 'Area confirmed at booking'}
            </p>
            <p className="text-xs sm:text-sm text-gray-600 mt-1">
              Exact address · check-in directions · host contact unlock after payment
            </p>
          </div>
        </div>
      </div>

      {maps?.maps_embed_url && (
        <div className="rounded-2xl overflow-hidden border border-gray-200 shadow-sm">
          <iframe
            title="Property area map"
            src={maps.maps_embed_url}
            className="w-full h-56 sm:h-64 border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      )}

      <div className="flex flex-wrap gap-2">
        {maps?.google_maps_url && (
          <a
            href={maps.google_maps_url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-xl bg-primary-500 text-secondary-900 px-4 py-2.5 text-sm font-semibold hover:bg-primary-400 transition-colors"
          >
            <MapPin className="h-4 w-4" />
            Open in Google Maps
            <ExternalLink className="h-3.5 w-3.5" />
          </a>
        )}
        {maps?.street_view_url && (
          <a
            href={maps.street_view_url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-xl border border-gray-200 bg-white px-4 py-2.5 text-sm font-semibold text-gray-800 hover:bg-gray-50 transition-colors"
          >
            <Eye className="h-4 w-4 text-primary-500" />
            Street View
            <ExternalLink className="h-3.5 w-3.5" />
          </a>
        )}
      </div>

      {maps?.plus_code && (
        <p className="text-xs text-gray-500">
          Plus code: <span className="font-mono text-gray-700">{maps.plus_code}</span>
        </p>
      )}
    </div>
  )
}

export default LocationTab
